<app-news-slide *ngIf="newsStore.news.length > 0" [newsList]="newsStore?.news"></app-news-slide>



